<template>
  <div class="departments-schedules-container p-4">
    <swiper-container
      class="departments-schedules"
      navigation-prev-el=".department-button-prev"
      navigation-next-el=".department-button-next"
      :slides-per-view="1"
      :loop="true"
      @swiperslidechange="onSlideChange($event)"
      ref="departmentSwiperRef"
    >
      <div class="d-flex align-items-center justify-content-between mb-2" slot="container-start">
        <div class="department-button-prev btn btn-primary bg-transparent text-white border-0">
          <AppIcon icon="previous" />
        </div>
        <h4>{{ departmentName }}</h4>
        <div class="department-button-next btn btn-primary bg-transparent text-white border-0">
          <AppIcon icon="next" />
        </div>
      </div>
      <swiper-slide
        v-for="[key, department] of departments"
        :id="key"
        :key="key"
        class="departments-schedules__item"
      >
        <div v-if="department">
          <ul class="clean-ul">
            <li
              v-for="(hours, index) in department.opening_hours_full"
              :key="index"
              class="row mb-2"
            >
              <div class="col-4 text-start">{{ hours.days }}</div>
              <div class="col-8 text-end">{{ hours.range }}</div>
            </li>
          </ul>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from 'vue'
import { DepartmentOpeningHours } from '~concierge/types/DepartmentTypes'
import { register } from 'swiper/element/bundle'
import { Swiper } from 'swiper/types'
import 'swiper/css'
import 'swiper/css/navigation'
register()

export default defineComponent({
  name: 'DepartmentsSchedules',
  props: {
    departmentOpeningHours: {
      type: Object as PropType<DepartmentOpeningHours>,
      required: true
    },
    lang: {
      type: String as PropType<string>,
      required: true
    }
  },
  setup() {
    const departmentSwiperRef = ref<Swiper | null>(null)
    const departmentName = ref<string>('')
    return { departmentSwiperRef, departmentName }
  },
  computed: {
    departments(): Map<string, any> {
      const departmentsMaps = new Map(Object.entries(this.departmentOpeningHours))
      if (departmentsMaps.size < 4) {
        const departmentsKeys = Object.keys(this.departmentOpeningHours)
        departmentsKeys.forEach(key => {
          departmentsMaps.set(key + 'duplicated', this.departmentOpeningHours[key])
        })
      }
      if (departmentsMaps.size < 4) {
        const departmentsKeys = Object.keys(this.departmentOpeningHours)
        departmentsKeys.forEach(key => {
          departmentsMaps.set(key + 'duplicated_2', this.departmentOpeningHours[key])
        })
      }
      if (departmentsMaps.size > 0) {
        const first = departmentsMaps.values().next().value
        if (first) {
          const name = this.lang === 'fr' ? first.name_fr : first.name_en
          this.departmentName = name
        }
      }

      return departmentsMaps
    }
  },
  methods: {
    onSlideChange(slide: CustomEvent): void {
      const [swiper] = slide.detail
      const slides = swiper.slides
      if (slides[swiper.realIndex]?.id) {
        const current = this.departments.get(slides[swiper.realIndex].id)
        const name = this.lang === 'fr' ? current.name_fr : current.name_en
        this.departmentName = name
      }
    }
  }
})
</script>

<style scoped lang="scss">
.departments-schedules-container {
  width: clamp(250px, 300px, 90vw);
  overflow: hidden;
}

.departments-schedules {
  display: flex;
  min-width: 230px;
}
</style>
